// extracted by css-extract-rspack-plugin
export default {"block":"Block-module__block--IWky3"};